import React from "react";
import { Col, Form, FormCheck, InputGroup, Row } from "react-bootstrap";
import { ButtonDanger, ButtonDark } from "../../ui/templates/buttons";
import Licence from "./licence";
import { DropdownForAssign } from "../../ui/templates/dropdown";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  IconButton,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";

class Driver extends React.Component {
  handleCheckboxChange = () => {
    const { i, handleSelectCaptain, selectedCaptainId } = this.props;
    if (selectedCaptainId !== i?.user_id) {
      handleSelectCaptain(i?.user_id);
    }
  };
  render() {
    const {
      i,
      k,
      team,
      handleSaveLicenseForSlot,
      handleDeleteUserFromSlot,
      handlePayClick,
      handleGetInvoice,
      handleAssignPayment,
      renderNumberOption,
      findByRole,
      handleEventDetailsPush,
      selectedCaptainId,
      handleDriverLicenseUpdate,
    } = this.props;
    const driverName = i.first_name
      ? i.first_name + " " + i.last_name
      : "Driver # " + (k + 1);
    return (
      <div key={k}>
        <Form.Group>
          <Box>
            <Accordion style={{ boxShadow: "none" }}>
              <AccordionSummary
                expandIcon={
                  <IconButton className="expandIcon">
                    <ExpandMore />
                  </IconButton>
                }
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{
                  background: "#f7f7f7",
                  border: "1px solid #d4d2d2",
                }}
              >
                <Form.Label className="bold">{driverName}</Form.Label>
              </AccordionSummary>
              <AccordionDetails>
                <Box width="100%">
                  <Row>
                    <Col md={6}>
                      <Box>
                        <Form.Group as={Row}>
                          <Box className="col-md-12">
                            <Form.Label className="InputformLabel">
                              Name
                            </Form.Label>
                            <Box>
                              <Form.Control
                                disabled
                                type="text"
                                placeholder="Name"
                                value={
                                  i?.first_name
                                    ? i?.first_name + " " + i?.last_name
                                    : ""
                                }
                                name="name"
                              />
                              <br />
                              {i?.user_id && !findByRole(team) && (
                                <Box mt={-2}>
                                  <FormCheck
                                    checked={selectedCaptainId === i?.user_id}
                                    type="checkbox"
                                    name={`markAsCaptain${k}`}
                                    value={i?.user_id}
                                    onChange={this.handleCheckboxChange}
                                    label="Mark as captain"
                                  />
                                </Box>
                              )}
                            </Box>
                          </Box>
                        </Form.Group>

                        <Form.Group as={Row}>
                          <Box className="col-md-12 cta-email">
                            <Form.Label className="InputformLabel">
                              Email
                            </Form.Label>
                            <Box>
                              <InputGroup className="mb-3">
                                <Form.Control
                                  disabled
                                  type="text"
                                  placeholder="Email"
                                  value={i.email}
                                  name="email"
                                />
                                <Box mt="6px">
                                  <InputGroup.Append>
                                    {i.email && !findByRole(team) ? (
                                      <ButtonDanger
                                        text="REJECT"
                                        onClick={() =>
                                          handleDeleteUserFromSlot(i.id)
                                        }
                                      />
                                    ) : (
                                      <ButtonDanger
                                        text="REJECT"
                                        disabled={true}
                                      />
                                    )}
                                  </InputGroup.Append>
                                </Box>
                              </InputGroup>
                            </Box>
                          </Box>
                        </Form.Group>
                        <Form.Group as={Row}>
                          <Box className="col-md-12" mt={-2}>
                            <Form.Label className="InputformLabel">
                              Driver/crew
                            </Form.Label>
                            <Box>
                              <Form.Control
                                disabled
                                type="text"
                                placeholder="Driver/crew"
                                value={i.type}
                                name="Driver/crew"
                              />
                            </Box>
                          </Box>
                        </Form.Group>
                        <Box className="raceLicence">
                          <Licence
                            handleSaveLicenseForSlot={handleSaveLicenseForSlot}
                            id={i.id}
                            user_id={i?.user_id}
                            license={i?.matchedLicense}
                            editAbleLicense={i?.license}
                            team={team}
                            handleEventDetailsPush={handleEventDetailsPush}
                            handleDriverLicenseUpdate={
                              handleDriverLicenseUpdate
                            }
                            findByRole={findByRole}
                          />
                        </Box>
                      </Box>
                    </Col>
                    <Col md={6} className="pr-0 cta-payment-buttons">
                      <Box
                        className="formButtonDanger"
                        display="flex"
                        flexDirection="column"
                        alignItems="end"
                      >
                        <Form.Group>
                          {i.payment_info === null ? (
                            <ButtonDanger
                              disabled={!i.is_payment_available}
                              text="Payment"
                              fullWidth
                              onClick={() => {
                                handlePayClick(i);
                              }}
                            />
                          ) : (
                            <ButtonDark fullWidth disabled={true} text="Paid" />
                          )}
                        </Form.Group>
                        <Form.Group>
                          {i.payment_info !== null && i.email !== null ? (
                            <ButtonDanger
                              fullWidth
                              text="Tax Invoice"
                              onClick={() => handleGetInvoice(i.id)}
                            />
                          ) : (
                            <ButtonDanger
                              fullWidth
                              disabled={true}
                              text="Tax Invoice"
                            />
                          )}
                        </Form.Group>
                        <Form.Group>
                          {i.payment_info !== null &&
                          i.email !== null &&
                          !findByRole(team) ? (
                            <DropdownForAssign
                              id={i.id}
                              items={renderNumberOption(
                                team.team_slots.drivers,
                                i.email
                              )}
                              onClick={handleAssignPayment}
                              text="Assign member"
                            />
                          ) : (
                            <ButtonDanger
                              fullWidth
                              disabled={true}
                              text="Assign member"
                            />
                          )}
                        </Form.Group>
                      </Box>
                    </Col>
                  </Row>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Box>
        </Form.Group>
      </div>
    );
  }
}
export default Driver;
